export const API_URL = "https://inkhivetattooco.com/api/wp-json/wp/v2";

export const PAGES = {
  home: "Home",
  about: "About",
  artists: "Artists",
  contact: "Contact",
};

export const ARTISTS = {
  xavier: {
    name: "xavier",
    gallery: "xavier-gallery",
  },
  alex: {
    name: "alex",
    gallery: "alex-gallery",
  },
  alexis: {
    name: "alexis",
    gallery: "alexis-gallery",
  },
  nick: {
    name: "nick",
    gallery: "nick-gallery",
  },
  pam: {
    name: "pam",
    gallery: "pam-gallery",
  },
  maria: {
    name: "maria",
    gallery: "maria-gallery",
  },
  brooklin: {
    name: "brooklin",
    gallery: "brooklin-gallery",
  },
  troy: {
    name: "troy",
    gallery: "troy-gallery",
  },
};

export const GALLERY_CATEGORIES = {
  homeSlideshow: "home-slideshow",
  homeGallery: "home-gallery",
  xavier: "xavier-gallery",
  alex: "alex-gallery",
  alexis: "alexis-gallery",
  nick: "nick-gallery",
  pam: "pam-gallery",
  maria: "maria-gallery",
  brooklin: "brooklin-gallery",
  troy: "troy-gallery",
  artists: "artists-page",
  about: "about-page",
};
